module.exports = __webpack_public_path__ + "img/doctors.06227813.svg";